import { Dispatch, FC, SetStateAction, useRef, useState } from "react";
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
} from "@mui/material";
import {
  GridCheckIcon,
  GridDensity,
  Toolbar,
  ToolbarButton,
} from "@mui/x-data-grid-pro";
import SettingsIcon from "@mui/icons-material/Settings";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import __ from "src/utils/Translations";
import { TableSettings } from "./tables.models";

interface SyncErrorsToolbarProps {
  settings: TableSettings;
  showFilters: boolean;
  setSettings: Dispatch<SetStateAction<TableSettings>>;
  setShowFilters: Dispatch<SetStateAction<boolean>>;
}

const DENSITY_OPTIONS: { label: string; value: GridDensity }[] = [
  { label: "Widok standardowy", value: "standard" },
  { label: "Widok komfortowy", value: "comfortable" },
];

const SyncErrorsToolbar: FC<SyncErrorsToolbarProps> = ({
  settings,
  showFilters,
  setSettings,
  setShowFilters,
}) => {
  const settingsMenuTriggerRef = useRef<HTMLButtonElement>(null);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);

  return (
    <Toolbar>
      <Stack
        direction="row"
        sx={{ justifyContent: "end", width: "100%", mr: "1rem" }}
      />

      <Tooltip title={__("Filtry")}>
        <ToolbarButton
          onClick={() => setShowFilters((value: boolean) => !value)}
        >
          {showFilters ? <FilterAltOffIcon /> : <FilterAltIcon />}
        </ToolbarButton>
      </Tooltip>
      <Tooltip title={__("Ustawienia")}>
        <ToolbarButton
          ref={settingsMenuTriggerRef}
          id="settings-menu-trigger"
          aria-controls="settings-menu"
          aria-haspopup="true"
          aria-expanded={settingsMenuOpen ? "true" : undefined}
          onClick={() => setSettingsMenuOpen(true)}
        >
          <SettingsIcon />
        </ToolbarButton>
      </Tooltip>
      <Menu
        id="settings-menu"
        anchorEl={settingsMenuTriggerRef.current}
        open={settingsMenuOpen}
        onClose={() => setSettingsMenuOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        disableAutoFocusItem
        disableScrollLock
        slotProps={{
          list: { "aria-labelledby": "settings-menu-trigger" },
        }}
      >
        {DENSITY_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() =>
              setSettings((prev) => ({ ...prev, density: option.value }))
            }
          >
            <ListItemIcon>
              {settings.density === option.value && (
                <GridCheckIcon fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Toolbar>
  );
};

export default SyncErrorsToolbar;
